import React, { useEffect } from "react";
import "fonts/ivypresto_headline_thin-webfont.woff2";
import "fonts/aileron-regular-webfont.woff2";

function LetterSeparator(props: any) {
  return (
    <>
      <span style={{ display: "inline-block" }}>
        {/* {props.word.split("").map((letter: string, letterIndex: number) => (
          <span>{letter}</span>
        ))} */}
        {props.word}
      </span>
    </>
  );
}

const offset = 1;
function ImageCon(props: any) {
  useEffect(() => {});
  return (
    <div
      data-scroll
      className={props.odd ? "imgcon__con --odd" : "imgcon__con"}
    >
      <h2
        className="year"
        data-scroll
        data-scroll-speed={props.odd ? "1.5" : "2"}
        data-scroll-delay=".2"
      >
        <LetterSeparator word={props.obj["Date"]} />
      </h2>
      <div className="imgcon__con--inner">
        <div className="img__con" data-scroll data-scroll-speed={0.9}>
          <img
            src={props.src}
            alt=""
            loading="lazy"
            data-scroll
            data-scroll-class="scrolled-in-View"
          />
        </div>
        <h3 data-scroll data-scroll-speed={offset}>
          {props.obj["Title"]}
        </h3>
        <p
          className="standard__copy"
          data-scroll
          data-scroll-speed={offset}
          data-scroll-delay=".07"
        >
          {props.obj["Copy"]}
        </p>
      </div>
    </div>
  );
}

export default function ImageSection(props: any) {
  return (
    <div className="imageSection">
      {props.obj.map((obj: any, i: number) => {
        if (i % 2) {
          return (
            <ImageCon
              src={"./assets/" + obj["Image File Name"]}
              odd={true}
              obj={obj}
            />
          );
        } else {
          return (
            <ImageCon src={"./assets/" + obj["Image File Name"]} obj={obj} />
          );
        }
      })}
    </div>
  );
}
